const breakpoint1239 = window.matchMedia('(max-width: 1239px)');
const breakpoint919 = window.matchMedia('(max-width: 919px)');
const breakpoint499 = window.matchMedia('(max-width: 499px)');

const calculateSlidesPerView = () => {
  if (document.documentElement.clientWidth > 1239) {
    return 4;
  } else if (document.documentElement.clientWidth > 919) {
    return 3;
  } else if (document.documentElement.clientWidth > 499) {
    return 2;
  } else {
    return 1;
  }
};

const initSiteSlider = () => {
  const sliders = document.querySelectorAll('.site-slider');

  if (!sliders.length) {
    return;
  }

  sliders.forEach((slider) => {
    const container = slider.querySelector('.site-slider__container');
    const slides = container.querySelectorAll('.site-slider__slide');
    const btns = slider.querySelector('.site-slider__btns');
    const prevBtn = btns.querySelector('.slider-btn--prev');
    const nextBtn = btns.querySelector('.slider-btn--next');
    const navigation = {
      prevEl: prevBtn,
      nextEl: nextBtn,
    };

    const checkIfNeedNavigation = () => slides.length > slidesPerView;


    let swiper;
    let slidesPerView = calculateSlidesPerView();
    let isNeedNavigation = checkIfNeedNavigation();

    const initSwiper = () => {
      // eslint-disable-next-line no-undef
      swiper = new Swiper(container, {
        slidesPerView,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        threshold: 10,
        navigation,
      });

      if (isNeedNavigation) {
        btns.style.display = null;
      } else {
        btns.style.display = 'none';
      }
    };

    const reInitSwiper = () => {
      slidesPerView = calculateSlidesPerView();
      isNeedNavigation = checkIfNeedNavigation();

      if (swiper) {
        swiper.destroy(true, true);
      }

      initSwiper();
    };

    initSwiper();

    breakpoint1239.addListener(reInitSwiper);
    breakpoint919.addListener(reInitSwiper);
    breakpoint499.addListener(reInitSwiper);
  });
};

export { initSiteSlider };
